import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          base: '#0184C3',
          darken1: '#0175af',
          darken2: '#00558e',
          lighten1: '#0a98d6',
          lighten2: '#11a6e5',
          lighten3: '#31b3e8',
          lighten4: '#53c0eb',
          lighten5: '#81d2f1',
          lighten6: '#b3e4f6',
          lighten7: '#e1f5fc',
        },
        info: '#c30186',
        error: '#c33e01',
        // secondary: '#424242',
        // accent: '#82B1FF',
        // error: '#FF5252',
        // info: '#2196F3',
        // success: '#4CAF50',
        // warning: '#FFC107'
      },
    },
  },
});
